// const prod = {
//     url: {
//         BASE_URL: 'https://a2.mhs.com/conners4',
//         API_URL: 'https://a2.mhs.com/rap_api/api'
//     }
// };

// const dev = {
//     url: {
//         BASE_URL: 'http://localhost:5000/',
//         API_URL: 'http://localhost:44367/api'
//     }
// };


const productIdNum = 4;

// const product = {
//     id:2,
//     version: 4
// }

const aiVersionsConst = [
    43,
    49,
    55,
    60,
    66,
    71,
    77,
    83
];

const terms = {
    accept: 1,
    declined: 2
}

const consent = {
    accept: 1,
    declined: 2
}

const status = {
    Complete: 'Complete' ,
    InProgress: 'InProgress',
    Fail: 'Fail'
}

export const config = window.globalConfig;
export const productId = productIdNum;
export const termsReponse = terms;
export const consentResponse = consent;
export const assessmentStatus = status;
export const aiVersions = aiVersionsConst;
